<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="header">
      <div class="title">
        <div class="label">
          {{'spotDrivers.spotDrivers' | translate}}
        </div>
        <div class="help" (click)="openVideoLink()">
          <!-- <app-help [helpData]="helpData" ></app-help> -->
          <img _ngcontent-frd-c8="" alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
        </div>
      </div>
      <div class="addSpotDriver mat-elevation-z4" (click)="openVehicleMapView();">
        <div class="button">
          {{'spotDrivers.vehicle_map_view' | translate}}
        </div>
      </div>
      <div class="addSpotDriver mat-elevation-z4" (click)="openSpotDriver();">
        <div class="button">
          {{'spotDrivers.addSpotDriver' | translate}}
        </div>
      </div>
    </div>
    <div class="table">
      <table mat-table *ngIf="driversList && driversList.filteredData.length; else noSpotDrivers"
        [dataSource]="driversList.filteredData">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <div class="inputContainer">
              <input type="text" [placeholder]="'spotDrivers.driverName' | translate" [(ngModel)]="filters.name"
                (keyup)="searchFilter(filters.name, 'name')">
              <i class="material-icons clearIcon" *ngIf="filters.name"
                (click)="filters.name = ''; clearFilter('name');"> clear </i>
            </div>
          </th>
          <td mat-cell *matCellDef="let row"> {{row.name}} </td>
        </ng-container>
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef>
            <div class="inputContainer">
              <input type="text" [(ngModel)]="filters.mobile" [placeholder]="'spotDrivers.mobile' | translate"
                (keyup)="searchFilter(filters.mobile, 'mobile')">
              <i class="material-icons clearIcon" *ngIf="filters.mobile"
                (click)="filters.mobile = ''; clearFilter('mobile');"> clear </i>
            </div>
          </th>
          <td mat-cell *matCellDef="let row"><img class="whatsapp" src="assets/whatsappround.svg" alt=""
              *ngIf="row.whatsApp"> {{row.mobile}}
            <div *ngIf="row.SecondaryMobile"><span title="Secondary Mobile Number">{{row.SecondaryMobile}}</span></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="vehicleNumber">
          <th mat-header-cell *matHeaderCellDef>
            <div class="inputContainer">
              <input type="text" [(ngModel)]="filters.vehicle_no"
                [placeholder]="'spotDrivers.vehicleNumber' | translate"
                (keyup)="searchFilter(filters.vehicle_no, 'vehicle_no')">
              <i class="material-icons clearIcon" *ngIf="filters.vehicle_no"
                (click)="filters.vehicle_no = ''; clearFilter('vehicle_no');"> clear </i>
            </div>
          </th>
          <td mat-cell *matCellDef="let row"> {{row.vehicleNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="vehicleType">
          <th mat-header-cell *matHeaderCellDef>
            <div class="input" style="display: flex; height: 50px;">
              <div class="currentLocation" style="padding-top: 5px;">
                <mat-select (closed)="searchFilter(filters.vehicle_type, 'vehicle_type')"
                  [placeholder]="'spotDrivers.vehicleType' | translate" [(ngModel)]="filters.vehicle_type">
                  <mat-option *ngFor="let vehicle of allVehicles" [value]="vehicle._id">
                    {{vehicle.name}}
                  </mat-option>
                </mat-select>
              </div>
              <i class="material-icons clearIcon" *ngIf="filters.vehicle_type"
                (click)="filters.vehicle_type = ''; clearFilter('vehicle_type');"
                style="margin-top: 17px;height: 14px;margin-left: 3px;"> clear </i>
            </div>
          </th>
          <td mat-cell *matCellDef="let row"> {{row.vehicleType}} </td>
        </ng-container>
        <ng-container matColumnDef="carrier">
          <th mat-header-cell *matHeaderCellDef>
            {{'spotDrivers.carrier' | translate}}
          </th>
          <td mat-cell *matCellDef="let row"> {{row.carrier}} </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>{{'spotDrivers.action' | translate}}</th>
          <td mat-cell *matCellDef="let row">
            <div class="buttons">
              <div class="button">
                <mat-select [placeholder]="'spotDrivers.action' | translate">
                  <mat-option [disabled]="row.whatsApp" (click)="(!row.whatsApp) ? optInWa(row) : ';'"><img
                      style="width: 16px;position: relative;top: 3px;" src="assets/whatsappround.svg" alt="">
                    {{'spotDrivers.optIn' | translate}}</mat-option>
                  <mat-option (click)="openEditDriver(row);"> <img style="width: 16px;position: relative;top: 3px;"
                      src="assets/icon-edit.svg" alt=""> {{'DRIVERS.edit' | translate}}</mat-option>
                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
      </table>
    </div>
    <mat-paginator [length]="(spotDrivers)? totalDrivers:0" [pageSize]="25" [pageSizeOptions]="[10, 15, 25, 50, 100]"
      showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>
  </div>
</div>
<ng-template #noSpotDrivers>
  <div class="noDriverLabel">
    {{'spotDrivers.noDrivers' | translate}}
  </div>
  <div class="clear">
    <div class="submitButtonClear">
      <div class="button" (click)="clear();">
        {{'spotDrivers.clear' | translate}}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #optIn>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'spotDrivers.optInForWa' | translate}}<i class="material-icons" (click)="optInRef.close();">clear</i>
        </div>
      </div>
      <div class="text">
        {{'spotDrivers.optInForWaText' | translate}}
      </div>
      <div class="submitButton">
        <div class="button" (click)="whatsapp();">
          Ok
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #openVideos>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'spotDrivers.add_spot_driver' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>